import React, { Component } from 'react'
import { css, StyleSheet } from 'aphrodite';
import { AppStyles } from '../../styles/AppTheme';
import { CustomTableComponentStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { Grid } from '@material-ui/core';
import { Helper } from '../../common/helpers/Helper';
import { AppButton } from '../../common/components/AppButton';
import moment from 'moment';
import { Controller } from '../../common/Controller';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Link } from 'react-router-dom';
import { NextPage } from '../../common/components/NextPage';

export class Tiles extends Component {
  constructor(props) {
    super(props)
  }

  getItemNavigationLink = (item) => {
    return `/admin/advertisers/${this.props.orgId}/campaigns/` + item.id
  }

  renderTiles() {
    return (
      <Grid container spacing={3}>
        {this.props.items.map((item, index) => {
          return (
            <Grid key={index} xs={12} sm={6} md={6} lg={4} item className={css(Styles.gridContainer)}>
              <div className={css(Styles.tileContainer)}>
                <p className={css(Styles.title)}>{item.title}</p>
                <p className={css(Styles.subTitle)}>ID: {item.id}</p>
                {/* {item.query && item.query.location && item.query.location.name &&
                  <p className={css(Styles.subTitle)}><span>
                    <img alt={Helper.getString('tileIcon')} className={css(Styles.tileIcon)} width={18} height={18} src={require('../../assets/images/location.svg')} /></span>
                  {item.query.location.name}
                  </p>
                } */}
                {(item.startTs || item.endTs) &&
                  <div className={css(Styles.subContainer)}>
                    {item.startTs &&
                      <p className={css(Styles.subTitle)}><span>
                        <img alt={Helper.getString('tileIcon')} className={css(Styles.tileIcon)} width={18} height={18} src={require('../../assets/images/calendar-2.svg')} /></span>
                      {AppHelper.formatCampaignTs(item.startTs)}
                      </p>
                    }
                    {/* {item.endTs &&
                      <p className={css(Styles.subTitle)}><span>
                        <img alt={Helper.getString('tileIcon')} className={css(Styles.tileIcon)} width={18} height={18} src={require('../../assets/images/calendar-2.svg')} /></span>
                      {AppHelper.formatCampaignTs(item.endTs)}
                      </p>
                    } */}
                  </div>
                }
                <div className={css(Styles.subContainer)}>
                  <p className={css(Styles.subTitle)}><span>
                    <img alt={Helper.getString('tileIcon')} className={css(Styles.tileIcon)} width={18} height={18} src={require('../../assets/images/monitor.svg')} />
                  </span>{(item.screens && item.screens.length || 0) + ' Screen(s)'}</p>
                  <p className={css(Styles.subTitle)}><span>
                    <img alt={Helper.getString('tileIcon')} className={css(Styles.tileIcon)} width={18} height={18} src={require('../../assets/images/document.svg')} />
                  </span>{(item.frequency || 0) + ' Ad Frequency'}
                  </p>
                </div>
                <div className={css(Styles.subContainer)}>
                  {item.state && AppHelper.renderCampaignState(item, this.props.org)}
                  <p className={css(Styles.subTitle)}>
                    <Link to={this.getItemNavigationLink(item)} className={css(Styles.detailLink)}>
                      <AppButton
                        buttonText={'Details'}
                        buttonStyle={Styles.buttonStyle}
                        buttonTextStyle={Styles.buttonTextStyle}
                      />
                    </Link>
                  </p>
                </div>
              </div>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  render() {
    return (
      <div className={css(AppStyles.entityContent, Styles.content)}>
        {this.props.items && this.props.items.length > 0 ?
          this.renderTiles()
          :
          UiHelper.emptyView(this.props.emptyText)
        }
        {this.props.nextPage &&
          (<NextPage
            itemCount={this.props.items.length}
            nextPageState={this.props.nextPageState}
            onNext={this.props.onNext}></NextPage>)}
      </div >
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomTableComponentStyles : StyleSheet.create({
  content: {
    overflow: 'hidden',
    paddingBottom: 40
  },
  gridContainer: {
    display: 'flex'
  },
  title: {
    fontSize: 22,
    lineHeight: '29px',
    color: '#1B1B1B',
    margin: 0,
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    borderRadius: '16px',
    boxSizing: 'border-box',
    flex: 1,
    gap: 16,
    backgroundColor: '#FFFFFF',
    maxWidth: '100%'
  },
  subContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: 10
  },
  subTitle: {
    fontSize: 14,
    lineHeight: '19px',
    color: '#747474',
    margin: 0,
    flex: 1,
    textAlign: 'left',
    display: 'flex',
    // textTransform: 'capitalize',
    alignItems: 'center'
  },
  tileIcon: {
    width: 18,
    height: 18,
    marginRight: 10
  },
  buttonStyle: {
    // backgroundColor: '#FFFFFF',
    // border: '1px solid ' + AppConfig.TINT_COLOUR,
    background: '#f5f5f5',
    borderRadius: '8px',
    height: 40,
    width: '100%',
    minWidth: 'unset'
  },
  buttonTextStyle: {
    fontSize: '16px',
    lineHeight: '21px',
    color: AppConfig.TINT_COLOUR,
    margin: 0,
    fontWeight: 700,
  },
  detailLink: {
    display: 'flex',
    flex: 1,
    textDecoration: 'none'
  }
})



// WEBPACK FOOTER //
// ./src/components/advertiser/Tiles.js